"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableHeadCells = void 0;
exports.tableHeadCells = [
    { name: "" },
    { name: "Component", width: 600 },
    { name: "Unit", align: "left", width: 600 },
    { name: "" },
];
